import React from 'react'
import { HiChevronDoubleRight } from "react-icons/hi";
import logo from '../assets/logo_bg.webp'
import { FaInstagram } from "react-icons/fa";
import { AiFillTikTok } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useTr, usePathLang } from '../lib/i18n';
import { pathLang, contactPath, aboutPath, CITY_RU } from '../lib/ru';

const CITY_NAMES = { ungheni: ['Ungheni', 'Унгены'], chisinau: ['Chișinău', 'Кишинёв'], balti: ['Bălți', 'Бельцы'] };

const Footer = () => {
    const lang = usePathLang();
    const tr = (ro, ru) => (lang === 'ru' ? ru : ro);

    const colGroups = [
        { city: 'balti', saleType: 1 },
        { city: 'balti', saleType: 2 },
        { city: 'ungheni', saleType: 1 },
        { city: 'ungheni', saleType: 2 },
        { city: 'chisinau', saleType: 1 },
        { city: 'chisinau', saleType: 2 },
    ];

    const items = {
        apartamente: tr('Apartamente', 'квартир'),
        case: tr('Case', 'домов'),
        'spatii-comerciale': tr('Spații comerciale', 'коммерческой недвижимости'),
        terenuri: tr('Terenuri', 'участков'),
    };

    const roomLabels = {
        '1-camera': tr('Apartamente cu 1 cameră', 'Квартиры с 1 комнатой'),
        '2-camere': tr('Apartamente cu 2 camere', 'Квартиры с 2 комнатами'),
        '3-camere': tr('Apartamente cu 3 camere', 'Квартиры с 3 комнатами'),
        '4-camere': tr('Apartamente cu 4+ camere', 'Квартиры с 4+ комнатами'),
    };

    return (
        <footer className='bg-[#181616] px-[12px] pt-[60px] sm:pt-[80px] lg:pt-[120px]'>
            <div className="sm:container sm:mx-auto flex flex-col">
                <div className="flex flex-col justify-center gap-[60px] pb-[60px] sm:pb-[80px] lg:pb-[120px]">
                    <div className="flex flex-col max-w-[400px] mx-auto lg:mx-0">
                        <img src={logo} alt={tr('LVG Imob - Agenție imobiliară - Logo', 'LVG Imob - Агентство недвижимости - Логотип')} width="150" height="85" className="w-[110px] lg:w-[150px] rounded-[5px] mx-auto sm:mx-0" />
                        <h2 className='font-body text-[18px] text-white text-center sm:text-left'>
                            {tr(
                                'LVG Imob este agenția ta imobiliară de încredere, dedicată să ofere servicii complete și personalizate pentru cumpărarea, vânzarea și închirierea proprietăților în Republica Moldova.',
                                'LVG Imob — ваше надёжное агентство недвижимости, которое предоставляет полный спектр услуг по покупке, продаже и аренде недвижимости в Республике Молдова.'
                            )}
                        </h2>
                    </div>

                    <div className="flex flex-col gap-[50px]">
                        <p className='font-poppins text-[20px] font-[500] text-white tracking-wide text-center'>{tr('Servicii', 'Услуги')}</p>
                        <div className="grid grid-rows-3 grid-cols-2 sm:grid-rows-2 sm:grid-cols-3 lg:grid-rows-1 lg:grid-cols-6 gap-[20px] font-body text-[14px] text-white justify-center">
                            {colGroups.map(({ city, saleType }) => (
                                <div key={`${city}-${saleType}`} className="flex flex-col gap-[15px]">
                                    {Object.entries(items).map(([base, label]) => {
                                        const roPath = `/${base}/${city}${saleType === 2 ? '/chirie' : ''}`;
                                        const action = saleType === 2 ? tr('Chirie', 'Аренда') : tr('Vânzare', 'Продажа');
                                        const cityName = lang === 'ru' ? CITY_RU[city]?.loc || CITY_NAMES[city][1] : CITY_NAMES[city][0];
                                        return (
                                            <Link key={base} to={pathLang(lang, roPath)} className="flex gap-[5px] group">
                                                <HiChevronDoubleRight className='text-[#d5ab63] min-w-[16px]' />
                                                <h2 className='group-hover:text-[#d5ab63] transition-all duration-100 ease-in'>{lang === 'ru' ? `${action} ${label} в ${cityName}` : `${action} ${label.toLowerCase()} ${tr('în', 'в')} ${cityName}`}</h2>
                                            </Link>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col gap-[50px]">
                        <p className='font-poppins text-[20px] font-[500] text-white tracking-wide text-center'>{tr('Apartamente după numărul de camere', 'Квартиры по количеству комнат')}</p>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-[20px] font-body text-[14px] text-white justify-center">
                            {['ungheni', 'chisinau', 'balti'].map((city) => (
                                <div key={city} className="flex flex-col gap-[15px]">
                                    <p className='text-[#d5ab63] font-[500]'>{CITY_NAMES[city][lang === 'ru' ? 1 : 0]}</p>
                                    {Object.entries(roomLabels).map(([slug, label]) => (
                                        <Link key={slug} to={lang === 'ru' ? `/ru/kvartiry/${city}/prodazha` : `/apartamente/${city}/${slug}`} className="flex gap-[5px] group">
                                            <HiChevronDoubleRight className='text-[#d5ab63] min-w-[16px]' />
                                            <h2 className='group-hover:text-[#d5ab63] transition-all duration-100 ease-in'>{label}</h2>
                                        </Link>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

                <hr className='text-gray-300 opacity-[0.5]'/>

                <div className="py-[30px] flex justify-center items-center sm:items-start sm:justify-between gap-[20px] sm:gap-[50px] opacity-[0.7] flex-col sm:flex-row ">
                    <h3 className='font-poppins text-gray-300 text-[18px] text-center'>© LVG Imob | {tr('Toate drepturile rezervate', 'Все права защищены')} | <a href="https://icode.md/ro/" className='text-[#e2c27d] underline' target='_blank'>{tr('Site creat de iCode', 'Сайт создан iCode')}</a></h3>
                    <div className="mx-auto xl:mx-0">
                        <div className="flex gap-[30px] text-white border-[1px] border-gray-100 p-[12px] rounded-[7px] text-2xl relative top-1/2">
                            <a href="https://www.instagram.com/lvgimob/" target='_blank' rel="noopener noreferrer" aria-label="Instagram LVG Imob"><FaInstagram className='hover:text-[#d5ab63] transition-all duration-100 ease-in'/></a>
                            <a href="https://www.tiktok.com/@lvg.imob1" target='_blank' rel="noopener noreferrer" aria-label="TikTok LVG Imob"><AiFillTikTok className='hover:text-[#d5ab63] transition-all duration-100 ease-in'/></a>
                            <a href="https://www.facebook.com/nicnicolas.nicnicolas/" target='_blank' rel="noopener noreferrer" aria-label="Facebook LVG Imob"><FaFacebookSquare className='hover:text-[#d5ab63] transition-all duration-100 ease-in'/></a>
                        </div>
                    </div>
                    <div className="flex gap-[20px] sm:gap-[30px] items-center">
                        <Link to={aboutPath(lang)} className='font-poppins text-gray-300 text-[18px] hover:text-[#d5ab63] transition-all duration-100 ease-in'>{tr('Despre noi', 'О нас')}</Link>
                        <Link to={contactPath(lang)} className='font-poppins text-gray-300 text-[18px] hover:text-[#d5ab63] transition-all duration-100 ease-in'>{tr('Contacte', 'Контакты')}</Link>
                    </div>
                </div>

                {/* Legal links — their own full-width row, side by side */}
                <div className="pb-[26px]">
                    <div className="flex flex-wrap justify-center items-center gap-x-[22px] gap-y-[8px] font-body text-[13px] text-gray-300 whitespace-nowrap">
                        <Link to={lang === 'ru' ? '/ru/politika-konfidentsialnosti' : '/politica-de-confidentialitate'} className="hover:text-[#d5ab63] transition-all duration-100 ease-in">{tr('Politica de confidențialitate', 'Политика конфиденциальности')}</Link>
                        <Link to={lang === 'ru' ? '/ru/usloviya-ispolzovaniya' : '/termeni-si-conditii'} className="hover:text-[#d5ab63] transition-all duration-100 ease-in">{tr('Termeni și condiții', 'Условия использования')}</Link>
                        <Link to={lang === 'ru' ? '/ru/politika-cookie' : '/politica-cookie'} className="hover:text-[#d5ab63] transition-all duration-100 ease-in">{tr('Politica privind cookie-urile', 'Политика использования файлов cookie')}</Link>
                        <button
                            type="button"
                            onClick={() => window.dispatchEvent(new Event('lvg-open-settings'))}
                            className="cursor-pointer hover:text-[#d5ab63] transition-all duration-100 ease-in"
                        >
                            {tr('Setări cookie', 'Настройки cookie')}
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
